var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"animate-notification"}},[(_vm.telegramEnabled)?_c('button',{staticClass:"btn btn-middle tg-notification-button",attrs:{"type":"button"},on:{"click":_vm.navigate}},[_vm._v(" Перейти в телеграм-бот "),_c('Telegram',{staticClass:"tg-notification-button__icon"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }